const GIS_SRC = 'https://accounts.google.com/gsi/client';

let scriptPromise: Promise<void> | null = null;

export function getGoogleClientId(): string | null {
  const id = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;
  return id && id.trim() ? id : null;
}

function loadScript(): Promise<void> {
  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${GIS_SRC}"]`);

    if (existing) {
      resolve();
      return;
    }

    const el = document.createElement('script');
    el.src = GIS_SRC;
    el.async = true;
    el.defer = true;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error('Failed to load Google Identity Services'));
    document.head.appendChild(el);
  });

  return scriptPromise;
}

export async function renderGoogleButton(
  container: HTMLElement,
  onCredential: (idToken: string) => void,
): Promise<void> {
  const clientId = getGoogleClientId();

  if (!clientId) {
    return;
  }

  await loadScript();

  const google = (window as unknown as { google?: any }).google;

  if (!google?.accounts?.id) {
    return;
  }

  google.accounts.id.initialize({
    client_id: clientId,
    callback: (response: { credential: string }) => onCredential(response.credential),
  });

  container.innerHTML = '';

  // GIS accepts 200–400px and never shrinks on its own; a fixed 360 was clipped inside a phone-width modal.
  const width = Math.max(200, Math.min(360, Math.floor(container.clientWidth || 360)));
  google.accounts.id.renderButton(container, { theme: 'outline', size: 'large', width });
}
